import React from 'react'

import Footer from '../Components/Footer'
import Dropdown from '../Components/Dropdown';
// import Quote from '../Components/Quote';

import Button from '../Components/Button';
import ArrowBarDown from '../Components/icons/ArrowBarDown';
import ArrowRight from '../Components/icons/ArrowRight';


import AppearOnScroll from '../Components/AppearOnScroll';
import Navigation from '../Components/Navigation';


// import Cta from '../Components/Cta'


export default function About() {
  // let {projectName} = useParams();

  let about = require("../about.json");

    return (
      
        <div className={"relative overflow-hidden"}>
          <Navigation/>
          <AppearOnScroll>
          <section className='flex flex-col pt-32 md:pt-48 xl:pt-52 px-4 md:px-16 lg:px-24 xl:px-48 gap-20 md:gap-20 pb-24 w-full overflow-x-hidden'>
            <div className='flex flex-col gap-8 lg:gap-24 items-start'>
              <div className='flex flex-col items-start gap-4 w-full'>
                <h1 className='font-display font-medium leading-medium text-3xl lg:text-5xl xl:text-7xl text-dark text-wrap text-left cursor-default'>A little about me</h1>
              </div>
              <div className='w-full flex flex-col md:flex-row gap-8 md:gap-16 lg:gap-24 items-start md:items-center'>
    
                <img src="/img/Profile-img.jpeg" alt='projects overview' className="w-80 md:w-40 object-cover rounded-image shadow-sm"/>
                
                <div className='xl:w-40 flex flex-col items-start gap-8'>
                <AppearOnScroll delay={0.2}>
                  <p className='w-full lg:w-80 xl:w-full text-left leading-relaxed font-body font-normal text-lg  md:text-lg xl:text-xl'>
                  {about.about}
                  {/* <br/><br/>{about.journey} */}
                  </p>
                  </AppearOnScroll>
                  
                  <div className='flex flex-row'>
                    <a href='/'>
                    {/* <Button icon={ArrowRight} iconPosition="right" variant="primary" className='group'>Let's talk</Button> */}
                      
                      </a>
                  </div>
                  
                    
                </div>
                
              </div>
            </div>
            <div className='flex flex-col gap-8 lg:gap-12'>
              {/* <Quote></Quote> */}
            <div className='flex flex-col w-full items-center'>
              <div className='md:w-80 lg:w-60 md:align-middle md:items-center items-start flex flex-col gap-8'>
              <h2 id="projects" className="font-display font-medium text-xl md:text-3xl text-dark">My journey</h2>
                <AppearOnScroll>
                  <p className="md:text-center text-left leading-relaxed font-body font-normal text-lg lg:text-lg xl:text-xl">{about.journey}</p>
                  </AppearOnScroll>
                  <AppearOnScroll>
                  <div className='content-initial'>
                    <a href="img/Resume_LisanneVerbeet.pdf" download="Resume_LisanneVerbeet.pdf">
                      <Button icon={ArrowBarDown} iconPosition="right" variant="primary" className='group'>Download resume</Button>
                    </a>
                  </div>  
                  </AppearOnScroll>
              </div>
            </div>

            </div>
            
              <div className='w-full flex flex-col align-top gap-8'>
                <h3 className='font-display font-medium text-2xl xl:text-2xl text-left'>Experiences outside the industry</h3>
                
                <div className='flex flex-col gap-px overflow-hidden rounded-image border-b border-lightgrey'>
                {about.listitems.map(section => (
                        <Dropdown
                        year={section.year}
                        title={section.title}
                        info={section.info}
                  /> 
                  ))}
                  </div>

                </div>
                {/* <div className='flex w-25'>
                  <img src='/img/Presentatie-hue-small.jpeg'alt='Presentation image' className="w-full object-cover rounded-image shadow-sm"/>
                </div> */}
                {/* <Cta></Cta> */}
                         
          </section>
          </AppearOnScroll>
          <Footer></Footer>   
        </div>
        
    )
  }